import { render, staticRenderFns } from "./TaskStatusFilterButton.component.vue?vue&type=template&id=c8a0d88e&scoped=true&"
import script from "./TaskStatusFilterButton.component.vue?vue&type=script&lang=js&"
export * from "./TaskStatusFilterButton.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusFilterButton.component.vue?vue&type=style&index=0&id=c8a0d88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a0d88e",
  null
  
)

export default component.exports